'use strict';

angular.module('clientDashboardApp').controller(
  'zoomImageController',
  function ($scope, $uibModalInstance) {
    $scope.noteSettings.newNote = false;
    $scope.noteSettings.newNoteItem = {};
    $scope.closeZoomImageModal = function () {
      $uibModalInstance.dismiss('cancel');
    }
    $scope.imageUrl = function() {
      var imageString = window.location.protocol + "//" + window.location.host + "/images/metas?imageUrl="
      imageString += encodeURIComponent($scope.selectedItem.imageUrl)
      imageString += "&contentProvider="
      imageString += $scope.selectedItem.contentProvider
      return imageString
    }
  }
);
